<div class="card-container">
  <mat-card fxLayout="column">
    <table
      mat-table
      class="mat-elevation-8 mat-typography"
      [dataSource]="dataSource"
      matSort
    >
      <ng-container matColumnDef="answer">
        <th *matHeaderCellDef mat-sort-header>Presa in carico</th>
        <td *matCellDef="let entity">
          <span
            *ngIf="entity.accepted"
            fxLayout="row"
            fxLayoutAlign="start center"
            ><mat-icon mat-list-icon class="green"
              >check_circle_outline</mat-icon
            >
            &nbsp;&nbsp;&nbsp;Accettato</span
          >

          <span
            *ngIf="entity.rejected"
            fxLayout="row"
            fxLayoutAlign="start center"
            ><mat-icon mat-list-icon class="red">highlight_off</mat-icon
            >&nbsp;&nbsp;&nbsp;Rifiutato</span
          >

          <span
            *ngIf="!entity.accepted && !entity.rejected"
            fxLayout="row"
            fxLayoutAlign="start center"
            ><mat-icon mat-list-icon>help_outline</mat-icon
            >&nbsp;&nbsp;&nbsp;Non risposto</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="pending">
        <th *matHeaderCellDef mat-sort-header></th>
        <td *matCellDef="let entity">
          {{ entity.pending ? "In attesa" : "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="proposalDate">
        <th *matHeaderCellDef mat-sort-header>Data proposta</th>
        <td *matCellDef="let entity">
          {{ entity.proposalDate.toDate() | date: "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="answerDate">
        <th *matHeaderCellDef mat-sort-header>Data risposta</th>
        <td *matCellDef="let entity">
          <span *ngIf="entity.answerDate">{{
            entity.answerDate.toDate() | date: "short"
          }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fee">
        <th *matHeaderCellDef mat-sort-header class="matHeaderCellDef-right">
          Compenso
        </th>
        <td *matCellDef="let entity" style="text-align: right">
          <b style="color: red" *ngIf="entity.test">TEST &nbsp;</b>
          <span
            style="display: inline-block; margin-right: 15px"
            [ngStyle]="{
              'text-decoration': entity.rejected ? 'line-through' : 'none'
            }"
            >{{ entity.fee | number: "1.2-2" }} €</span
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="go(row)"
        [ngStyle]="{ cursor: row.pending ? 'pointer' : 'default' }"
      ></tr>
    </table>
  </mat-card>
</div>
